<template>
  <div>
    <!-- KI 5Jun2024 commented out below question. -->
    <!-- Request from Communications 30May2024 (Jayden Tran). -->
    <!-- <p>Do you know your Land Value?</p> -->
    <form class="container" @submit.prevent="onSubmit">
      <div class="form-row">
        <div class="col-6">
          <label>
            <!-- Request from Communications 30May2024 (Jayden Tran). -->
            <!-- KI 5Jun2024. Changed below text. -->
            <!-- "Yes, I know my Land Value." to "My land value is ...". -->
            <input type="radio" name="landValueKnown" v-model="landValueKnown" value="true"/>
            My land value is ...
          </label>
        </div>
        <div class="col-6">
          <label>
            <!-- Request from Communications 30May2024 (Jayden Tran). -->
            <!-- KI 5Jun2024. Changed below text. -->
            <!-- "No, retrieve this using my Rates Assessment Number." -->
            <!-- To "My Rates Assessment Number is ..." -->
            <input type="radio" name="landValueKnown" v-model="landValueKnown" value="false"/>
            My Rates Assessment Number is ...
          </label>
        </div>
      </div>
      <div>
        <label v-if="landValueKnown === 'true'">
          Please enter your land value (without commas):
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                $
              </span>
            </div>
            <input type="text" class="form-control" v-model="value"/>
          </div>
        </label>
        <label v-else-if="landValueKnown === 'false'">
          Please enter your assessment number:
          <input type="text" class="form-control" v-model="assessment"/>
        </label>
      </div>
      <button type="submit" class="btn btn-primary" :disabled="!ready">Continue</button>
      <p v-if="landValueKnown === 'false'">Here is where you can find the Assessment Number on your Rates Notice:</p>
      <img v-if="landValueKnown === 'false'" src="AssessmentNumber.jpg"  alt="Diagram showing where the Assessment Number is."/>
      <p v-if="error">{{error}}</p>
    </form>
  </div>
</template>

<script>
    import {API} from '@/config';

    export default {
        name: "Search",
        computed: {
            ready() {
                return (this.landValueKnown === 'true' && this.value !== '') ||
                    (this.landValueKnown === 'false' && this.assessment !== '');
            }
        },
        data() {
            return {
                landValueKnown: "",
                value: "",
                assessment: "",
                error: ""
            }
        },
        methods: {
            onSubmit() {
                this.submitValue(this);
            },
            submitValue: async (self) => {
                if (self.landValueKnown === 'false') {
                    let assNum = self.assessment.slice(0, -1);
                    let response = await (await fetch(`${API}/api/internal/forms/validations/assessmentnumber?assessment_number=${assNum}`)).json()
                    if (response['error']) {
                        self.error = response['error'];
                        return;
                    }
                    self.error = '';
                    self.value = response['landValue'];
                }
                let floatValue = parseFloat(self.value.replace(/,/g, ''));
                if(isNaN(floatValue)) {
                    return false;
                }
                self.$emit('rate-found', floatValue);
            }
        }
    }
</script>

<style scoped>
img {
  display:block;
  margin-left: auto;
  margin-right: auto;
}
</style>